import { ErrorBoundary } from "@sentry/react";
import { FullPageError } from "pages";
import { setConfiguration } from "react-grid-system";
import { RouterProvider } from "react-router-dom";

import {
  DesignSystemProvider,
  MediaQueryProvider,
  Toast,
} from "@icg360/design-system";

import { SSDataStoreProvider } from "data/ss-data-store";
import "stylesheets/main.scss";
import { setMixpanelSuperProperties, trackEvent, useFlags } from "utils";

import { router } from "./router";

setConfiguration({
  breakpoints: [576, 768, 992, 1200, 1600],
  containerWidths: [540, 768, 970, 1200],
  maxScreenClass: "xl",
});

const Root = () => {
  const flags = useFlags();
  setMixpanelSuperProperties({
    featureFlags: Object.keys(flags).map(
      (key) => `${key}/${String(flags[key])}`,
    ),
  });

  return (
    <ErrorBoundary
      fallback={() => <FullPageError />}
      onError={(error) => trackEvent("MSS Error", { error })}
    >
      <SSDataStoreProvider>
        <DesignSystemProvider>
          <MediaQueryProvider>
            <App />
            <Toast />
          </MediaQueryProvider>
        </DesignSystemProvider>
      </SSDataStoreProvider>
    </ErrorBoundary>
  );
};

const App = () => {
  return <RouterProvider router={router()} />;
};

export default Root;
